import HTTP from '@/framework/utilities/http'

export default {
  checkInClient ({ id, clientId }) {
    this.updateStatus({ id: id, clientId: clientId, status: 'Waiting' })
  },

  getById ({ id }) {
    return HTTP.post(`appointments/getById?appointmentId=${id}`)
  },

  search ({ startDate, endDate, locations }) {
    let query = {
      startDate: startDate,
      endDate: endDate,
      locations: locations
    }
    return HTTP.post('appointments/search', query)
  },

  updateStatus ({ id, clientId, status }) {
    let query = {
      AppointmentId: id,
      ClientId: clientId,
      Status: status
    }

    return HTTP.post('appointments/updateAppointmentStatus', query)
  }
}
